<template>
  <div>
    <CustomPageHeaderVue>{{ $t('member_terms_title') }}</CustomPageHeaderVue>
    <CustomRow>
      <v-card class="mt-5 cusPadding">
        <h4 class="text-center">{{ $t('terms_terms_title') }}</h4>
        <div class="font-weight-bold mb-3 mt-5">{{ $t('terms_terms_list_1') }}</div>
        <ol>
          <li>{{ $t('terms_terms_list_1_item_1') }}</li>
        </ol>
        <div class="font-weight-bold mb-3 mt-5">
          {{ $t('terms_terms_list_2') }}
        </div>
        <ol>
          <li>{{ $t('terms_terms_list_2_item_1') }}</li>
          <li>{{ $t('terms_terms_list_2_item_2') }}</li>
          <li>{{ $t('terms_terms_list_2_item_3') }}</li>
          <li>{{ $t('terms_terms_list_2_item_4') }}</li>
        </ol>
        <div class="font-weight-bold mb-3 mt-5">
          {{ $t('terms_terms_list_3') }}
        </div>
        <ol>
          <li>{{ $t('terms_terms_list_3_item_1') }}</li>
        </ol>
        <div class="font-weight-bold mb-3 mt-5">
          {{ $t('terms_terms_list_4') }}
        </div>
        <ol>
          <li>{{ $t('terms_terms_list_4_item_1') }}</li>
          <li>{{ $t('terms_terms_list_4_item_2') }}</li>
        </ol>
        <div class="font-weight-bold mb-3 mt-5">
          {{ $t('terms_terms_list_5') }}
        </div>
        <ol>
          <li>{{ $t('terms_terms_list_5_item_1') }}</li>
          <li>{{ $t('terms_terms_list_5_item_2') }}</li>
          <li>{{ $t('terms_terms_list_5_item_3') }}</li>
          <li>{{ $t('terms_terms_list_5_item_4') }}</li>
          <li>{{ $t('terms_terms_list_5_item_5') }}
            <ul class="mt-3">
              <li>{{ $t('terms_terms_list_5_item_5_1') }}</li>
              <li>{{ $t('terms_terms_list_5_item_5_2') }}</li>
            </ul>
          </li>
          <li>{{ $t('terms_terms_list_5_item_6') }}</li>
          <li>{{ $t('terms_terms_list_5_item_7') }}</li>
        </ol>
        <div class="font-weight-bold mb-3 mt-5">
          {{ $t('terms_terms_list_6') }}
        </div>
        <ol>
          <li>{{ $t('terms_terms_list_6_item_1') }}
            <ul class="mt-3">
              <li>{{ $t('terms_terms_list_6_item_1_1') }}
              </li>
              <li>{{ $t('terms_terms_list_6_item_1_2') }}
              </li>
            </ul>
          </li>
          <li>{{ $t('terms_terms_list_6_item_2') }}
          </li>
        </ol>
        <div class="font-weight-bold mb-3 mt-5">
          {{ $t('terms_terms_list_7') }}
        </div>
        <ol>
          <li>
            {{ $t('terms_terms_list_7_item_1') }}
          </li>
        </ol>
        <div class="font-weight-bold mb-3 mt-5">
          {{ $t('terms_terms_list_8') }}</div>
        <div class="ml-6 mb-3">
          {{ $t('terms_terms_list_8_item_1') }}
        </div>
        <ol>
          <li>
            {{ $t('terms_terms_list_8_item_1_1') }}
          </li>
          <li>
            {{ $t('terms_terms_list_8_item_1_2') }}
          </li>
          <li>
            {{ $t('terms_terms_list_8_item_1_3') }}
          </li>
          <li>
            {{ $t('terms_terms_list_8_item_1_4') }}
          </li>
          <li>
            {{ $t('terms_terms_list_8_item_1_5') }}
          </li>
        </ol>
        <div class="font-weight-bold mb-3 mt-5">{{ $t('terms_terms_list_9') }}</div>
        <ol>
          <li>
            {{ $t('terms_terms_list_9_item_1') }}
          </li>
          <li>
            {{ $t('terms_terms_list_9_item_2') }}
          </li>
          <li>
            {{ $t('terms_terms_list_9_item_3') }}
          </li>
        </ol>
        <div class="font-weight-bold mb-3 mt-5">
          {{ $t('terms_terms_list_10') }}</div>
        <ol>
          <li>
            {{ $t('terms_terms_list_10_item_1') }}
          </li>
          <li>
            {{ $t('terms_terms_list_10_item_2') }}
          </li>
          <li>
            {{ $t('terms_terms_list_10_item_3') }}
          </li>
        </ol>
      </v-card>
      <v-card class="mt-5 cusPadding" id="privacy">
        <h4 class="text-center">{{ $t('terms_privacy_title') }}</h4>
        <div class="mt-5">
          {{ $t('terms_privacy_content') }}
        </div>
        <div class="font-weight-bold mb-3 mt-5">
          {{ $t('terms_privacy_list_1') }}
        </div>
        <ol>
          <li>
            {{ $t('terms_privacy_list_1_item_1') }}
          </li>
        </ol>
        <div class="font-weight-bold mb-3 mt-5">
          {{ $t('terms_privacy_list_2') }}
        </div>
        <ol>
          <li>
            {{ $t('terms_privacy_list_2_item_1') }}
            <ul class="mt-3">
              <li>
                {{ $t('terms_privacy_list_2_item_1_1') }}
              </li>
              <li>
                {{ $t('terms_privacy_list_2_item_1_2') }}
              </li>
              <li>
                {{ $t('terms_privacy_list_2_item_1_3') }}
              </li>
              <li>
                {{ $t('terms_privacy_list_2_item_1_4') }}
              </li>
              <li>
                {{ $t('terms_privacy_list_2_item_1_5') }}
              </li>
              <li>
                {{ $t('terms_privacy_list_2_item_1_6') }}
              </li>
              <li>
                {{ $t('terms_privacy_list_2_item_1_7') }}
              </li>
              <li>
                {{ $t('terms_privacy_list_2_item_1_8') }}
              </li>
              <li>
                {{ $t('terms_privacy_list_2_item_1_9') }}
              </li>
            </ul>
          </li>
        </ol>
        <div class="font-weight-bold mb-3 mt-5">
          {{ $t('terms_privacy_list_3') }}
        </div>
        <ol>
          <li>
            {{ $t('terms_privacy_list_3_item_1') }}
          </li>
          <li>
            {{ $t('terms_privacy_list_3_item_2') }}
          </li>
          <li>
            {{ $t('terms_privacy_list_3_item_3') }}
          </li>
          <li>
            {{ $t('terms_privacy_list_3_item_4') }}
          </li>
          <li>
            {{ $t('terms_privacy_list_3_item_5') }}
          </li>
        </ol>
        <div class="font-weight-bold mb-3 mt-5">
          {{ $t('terms_privacy_list_4') }}
        </div>
        <ol>
          <li>
            {{ $t('terms_privacy_list_4_item_1') }}
          </li>
          <li>
            {{ $t('terms_privacy_list_4_item_2') }}
          </li>
          <li>
            {{ $t('terms_privacy_list_4_item_3') }}
          </li>
          <li>
            {{ $t('terms_privacy_list_4_item_4') }}
          </li>
        </ol>
        <div class="font-weight-bold mb-3 mt-5">
          {{ $t('terms_privacy_list_5') }}
        </div>
        <ol>
          <li>
            {{ $t('terms_privacy_list_5_item_1') }}
          </li>
          <li>
            {{ $t('terms_privacy_list_5_item_2') }}
          </li>
          <li>
            {{ $t('terms_privacy_list_5_item_3') }}
          </li>
          <li>
            {{ $t('terms_privacy_list_5_item_4') }}
          </li>
          <li>
            {{ $t('terms_privacy_list_5_item_5') }}
          </li>
        </ol>
      </v-card>
    </CustomRow>
  </div>
</template>

<script>
import CustomPageHeaderVue from '@/components/CustomPageHeader.vue';
export default {
  components: { CustomPageHeaderVue },
  metaInfo() {
    return {
      title: `${this.$t('terms_title')} - ${this.$t('app_name')}`,
      meta: [
        {
          property: 'og:title',
          content: `${this.$t('terms_title')} - ${this.$t('app_name')}`,
          vmid: 'og:title'
        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        }
      ],
      script: [{
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": `${this.$t('terms_title')} - ${this.$t('app_name')}`,
          "url": window.location.href
        }
      }]
    }
  },
  mounted() {
    if (this.$route.hash) {
      this.$vuetify.goTo(this.$route.hash);
    }
    this.$gtm.trackView(`相關條款`, this.$route.path);
    this.$store.dispatch("setOverlayLoading", false);
  }
};
</script>

<style lang="scss" scoped>
.cusPadding {
  padding: 30px 155px;

  @media screen and (max-width: 600px) {
    padding: 30px 30px;
  }

  @media only screen and (min-width: 600px) and (max-width: 960px) {
    padding: 30px 50px;
  }
}

.title {
  text-align: center;
  font-weight: bold;
}

li {
  line-height: 1.6;
  margin-bottom: 10px;
}

ul {
  list-style-type: disc;
}
</style>
